<template>
  <div class="athlete-registration-certificate">
    <header>
      <span style="margin:0 36px 20px 0;">{{schoolName}}运动员注册证</span>
      <el-select
        v-if="userType === 4 || userType === 3"
        :popper-append-to-body="false"
        style="width:300px;margin:0 20px 20px 0;"
        clearable
        v-model="query.matchId"
        placeholder="选择赛事"
        @change="selectMatch"
      >
        <template v-if="userType === 4">
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.matchId"
            :label="item.matchName"
          ></el-option>
        </template>
        <template v-else>
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </template>
      </el-select>
      <el-input
        v-model="query.keyword"
        clearable
        placeholder="关键词搜索"
        style="width:390px;margin:0 20px 20px 0;"
        @keyup.enter.native="handleSearch"
      >
        <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
      </el-input>
      <el-button style="width:90px;margin:0 20px 20px 0;" type="warning" @click="print">打印</el-button>
      <el-button type="primary" style="width:90px;margin:0 0 20px 0" @click="getPdf()">导出PDF</el-button>
    </header>
    <div>
      <ul class="student_regist" style="display:flex;flex-wrap:wrap;list-style:none">
        <li
          v-for="(item,index) in list"
          :key="index"
          style="border: 1px solid #979797;width: 370px;padding: 30px 10px 30px 20px;margin: 0 16px 16px 0;"
        >
          <section class="head_img" style="width:160px;height:200px;margin:0 auto;">
            <img style="width:100%;height:100%" :src="item.headImage" alt />
          </section>
          <section
            class="student_info_box"
            style="display: flex;justify-content: space-between;margin-top: 20px;color: #444;"
          >
            <ul class="student_info_left" style="width: 100%;">
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p class="left_width" style="flex: 1;margin:0;">
                  姓名
                  <span style="font-size: 14px;font-weight: 400;">{{item.name}}</span>
                </p>
                <p class="right_width" style="width:150px;margin:0;">
                  性别
                  <span style="font-size: 14px;font-weight: 400;">{{!item.gender?'女':'男'}}</span>
                </p>
              </li>
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p class="left_width" style="flex: 1;margin:0;">
                  民族
                  <span style="font-size: 14px;font-weight: 400;">{{item.nation}}</span>
                </p>
                <p class="right_width" style="width:150px;margin:0;">
                  出生
                  <span style="font-size: 14px;font-weight: 400;">{{item.birthday}}</span>
                </p>
              </li>
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p style="margin:0;padding:0">
                  学校
                  <span style="font-size: 14px;font-weight: 400;">{{item.schoolName}}</span>
                </p>
              </li>
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p class="left_width" style="flex: 1;margin:0;">
                  专业
                  <span style="font-size: 14px;font-weight: 400;">{{item.major}}</span>
                </p>
                <p class="right_width" style="width:150px;margin:0;">
                  学制
                  <span
                    style="font-size: 14px;font-weight: 400;"
                  >{{schoolSystem(item.schoolSystem)}}</span>
                </p>
              </li>
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p class="left_width" style="flex: 1;margin:0;">
                  组别
                  <span style="font-size: 14px;font-weight: 400;">{{registGroup(item.group)}}</span>
                </p>
                <p class="right_width" style="width:150px;margin:0;">
                  类别
                  <span
                    style="font-size: 14px;font-weight: 400;"
                  >{{item.type === 1?'阳光体育':'竞技项目'}}</span>
                </p>
              </li>
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p style="margin:0;">
                  首次注册时间
                  <span style="font-size: 14px;font-weight: 400;">{{item.startSchoolDate}}</span>
                </p>
              </li>
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p style="margin:0;">
                  注册号
                  <span style="font-size: 14px;font-weight: 400;">{{item.registerNumber}}</span>
                </p>
              </li>
              <li
                style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;"
              >
                <p style="margin:0;">
                  有效期
                  <span
                    style="font-size: 14px;font-weight: 400;"
                  >{{effectiveTime(item.startSchoolDate,item.endSchoolDate)}}</span>
                </p>
              </li>
            </ul>
          </section>
        </li>
      </ul>
    </div>
    <el-pagination
      v-if="list.length > 0"
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <athleteRegistrationPrint :list="list" ref="studentRegist"></athleteRegistrationPrint>
    <athleteRegistrationPdf :list="list" ref="athletePdf"></athleteRegistrationPdf>
  </div>
</template>
<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { getSignListBySchool } from "@/api/sign-up-match";
import { getMatchList } from "@/api/sports-management";
import athleteRegistrationPrint from "./components/athlete-registration-print";
import athleteRegistrationPdf from "./components/athlete-registration-pdf";
import { getAthleteList } from "@/api/athletes";
import { page } from "@/common/js/mixins";
import { method } from "@/utils/utils";
import registerData from "@/assets/json/register.json";
import { getSession } from "@/utils/storage";
export default {
  mixins: [page],
  components: {
    athleteRegistrationPrint,
    athleteRegistrationPdf
  },
  data() {
    return {
      matchList: [],
      list: [],
      pageSizeList: [10, 25, 50, 100, 2000],
      userType: JSON.parse(getSession("userInfo")).type,
      htmlTitle: JSON.parse(getSession("userInfo")).schoolName + "运动员注册证",
      query: {
        matchId: "",
        keyword: ""
      },
      schoolName: JSON.parse(getSession("userInfo")).schoolName || ""
    };
  },
  computed: {
    // 筛选学制
    schoolSystem() {
      return data => {
        let label = "";
        registerData.educationalList.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 筛选组别
    registGroup() {
      return data => {
        let label = "";
        registerData.registGroup.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 有效期
    effectiveTime() {
      return (data, end) => {
        return data + " 至 " + end;
      };
    }
  },
  methods: {
    // 选择赛事
    selectMatch(value) {
      this.pageNo = 1;
      this.getList();
    },
    downloadPDF(ele, pdfName) {
      let that = this;
      this.loading = this.$loading({
        lock: false,
        text: "PDF生成中...",
        spinner: "el-icon-loading"
      });

      var el = document.querySelector("#athletePdf");
      let eleW = el.offsetWidth; // 获得该容器的宽
      let eleH = el.offsetHeight; // 获得该容器的高
      let eleOffsetTop = el.offsetTop; // 获得该容器到文档顶部的距离
      let eleOffsetLeft = el.offsetLeft; // 获得该容器到文档最左的距离
      let exportPdf = document.querySelectorAll(".export_pdf");
      for (let i = 0; i < exportPdf.length; i++) {
        for (let j = i + 1; j < exportPdf.length; j++) {
          if (exportPdf[i].clientHeight !== exportPdf[j].clientHeight) {
            exportPdf[j].style.height = exportPdf[i].clientHeight + "px";
          }
        }
      }
      var canvas = document.createElement("canvas");
      var abs = 0;

      let win_in =
        document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
      let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）

      if (win_out > win_in) {
        // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
        // console.log(a, '新abs');
      }
      canvas.width = eleW * 2; // 将画布宽&&高放大两倍
      canvas.height = eleH * 2;

      var context = canvas.getContext("2d");
      context.scale(2, 2);
      context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉
      html2Canvas(el, {
        dpi: 300,
        // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
        useCORS: true //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      }).then(canvas => {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = (595.28 / contentWidth) * contentHeight;
        var pageData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new JsPDF("", "pt", "a4");
        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          //在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
          pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        //可动态生成
        pdf.save(pdfName);
        that.loading.close();
      });
    },
    // 分会管理员获取赛事
    getMatchForManager() {
      return new Promise((resolve, reject) => {
        getMatchList({
          project: JSON.parse(getSession("userInfo")).project,
          pageNo: 1,
          pageSize: 999
        })
          .then(res => {
            this.matchList = [];
            if (res.list.length > 0) {
              this.matchList = res.list;
            }
            resolve("success");
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 注册员获取赛事
    getMatch() {
      return new Promise((resolve, reject) => {
        getSignListBySchool({})
          .then(res => {
            this.matchList = res;
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 导出PDF
    getPdf() {
      this.downloadPDF("athletePdf", "运动员注册证");
    },
    // 打印
    print() {
      var el = document.querySelector("#studentRegist"),
        iframe = document.createElement("IFRAME"),
        doc = null;
      iframe.setAttribute("id", "print-iframe");
      iframe.setAttribute(
        "style",
        "width:100%;font-size:20px;text-align:center"
      );
      document.body.appendChild(iframe);
      doc = iframe.contentWindow.document;
      doc.write(
        '<html><head><style type="text/css" media="all">ul{list-style:none} @page {size: auto; margin: 0mm 0mm;}</style></head><body style="zoom: 70%;">' +
          el.innerHTML +
          "</body></html>"
      );
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      getAthleteList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        allProject: this.query.matchId ? 1 : ""
      })
        .then(res => {
          this.total = res.total;
          res.list.filter(item => {
            item.birthday = method.timeFormat(item.birthday, "utf");
            item.startSchoolDate = item.startSchoolDate
              ? method.timeFormat(item.startSchoolDate, "utf")
              : "";
            item.endSchoolDate = item.endSchoolDate
              ? method.timeFormat(item.endSchoolDate, "utf")
              : "";
          });
          this.list = res.list;
        })
        .catch(err => {});
    }
  },
  mounted() {
    if (this.userType === 4) {
      this.getMatch()
        .then(res => {
          this.getList();
        })
        .catch(err => {});
    } else if (this.userType === 3) {
      this.getMatchForManager()
        .then(res => {
          this.getList();
        })
        .catch(err => {});
    } else {
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.athlete-registration-certificate {
  position: relative;
}
header {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > span {
    font-size: 24px;
    color: #222;
  }
}
.student_regist {
  display: flex;
  flex-wrap: wrap;
  margin-top:20px;
  > li {
    border: 1px solid #979797;
    width: 380px;
    padding: 30px 10px 30px 20px;
    margin: 0 16px 16px 0;
    .head_img {
      width: 160px;
      height: 200px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .student_info_box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      color: #444;
      .student_info_left,
      .student_info_right {
        width: 100%;
        li {
          font-size: 16px;
          margin-bottom: 10px;
          display: flex;
          font-weight: 600;
          align-items: flex-start;
          &.empty {
            visibility: hidden;
          }
          .right_width {
            width: 150px;
          }
          .left_width {
            flex: 1;
          }
          span {
            font-size: 14px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>